(function(window1) {
    const showDemoButtons = document.querySelectorAll('.showDemo');
    const demoModal = document.getElementById('demoModal');
    const content = demoModal.querySelector('.content');
    const closeIcon = content.querySelector('.text svg');
    const form = content.querySelector('form');
    const okButton = content.querySelector('.ok');
    const button = content.querySelector('button.send');
    const inputs = form.querySelectorAll('input:not([type=hidden]');
    const api = form.action;
    const validationRules = {
        name: /.{2,}/g,
        email: /.*@.*\..*/g,
        phone: /.{2,}/g,
        project: /.{2,}/g,
        comment: /.?/g
    };
    showDemoButtons.forEach((item)=>{
        item.onclick = (e)=>{
            e.preventDefault();
            demoModal.style.display = 'flex';
            window1?.dataLayer?.push({
                event: 'request_demo_form_view'
            });
            window1.location.hash = '#form-demo';
            document.body.style.overflow = 'hidden';
        };
    });
    content.onmousedown = (e)=>{
        e.stopPropagation();
    };
    [
        okButton,
        demoModal,
        closeIcon
    ].forEach((item)=>{
        item.onmousedown = ()=>{
            content.classList.remove('success');
            demoModal.style.display = 'none';
            window1.location.hash = '';
            history.replaceState(null, null, ' ');
            document.body.style.overflow = '';
        };
    });
    Array.prototype.last = function() {
        return this[this.length - 1];
    };
    const isEmailValid = (email, rule)=>{
        const notCorporateDomains = [
            'yandex.ru',
            'yandex.kz',
            'yandex.by',
            'yandex.com',
            'ya.ru',
            'narod.ru',
            'mail.ru',
            'mail.com',
            'inbox.ru',
            'list.ru',
            'bk.ru',
            'internet.ru',
            'rambler.ru',
            'rambler.ua',
            'lenta.ru',
            'autorambler.ru',
            'myrambler.ru',
            'ro.ru',
            'gmail.com',
            'gmail.ru',
            'googlemail.com',
            'yahoo.com',
            'aol.com',
            'comcast.net',
            'hotmail.com',
            'outlook.com',
            'icloud.com'
        ];
        return !!email.match(rule) && !notCorporateDomains.includes(email.split('@').last().replaceAll(' ', ''));
    };
    const isInputValid = (input, isEmail)=>{
        const rule = validationRules[input.name];
        return isEmail ? isEmailValid(input.value, rule) : input.value.match(rule);
    };
    const validateForm = ()=>{
        let isFormValid = [];
        inputs.forEach((item)=>{
            const isValid = isInputValid(item, item.name === 'email');
            if (isValid) isFormValid.push(true);
            else isFormValid.push(false);
        });
        return isFormValid;
    };
    const updateInputsClasses = ()=>{
        let isFormValid = [];
        inputs.forEach((item)=>{
            const isEmail = item.name === 'email';
            const isValid = isInputValid(item, isEmail);
            const isEmailFilled = isEmail && item.value.length > 0;
            const inputWrapper = item.parentElement.parentElement;
            if (isValid) {
                inputWrapper.classList.remove('invalid');
                isFormValid.push(true);
            } else {
                button.classList.add('invalid');
                inputWrapper.classList.add('invalid');
                isFormValid.push(false);
            }
            if (isEmailFilled) inputWrapper.classList.add('filled');
            else inputWrapper.classList.remove('filled');
        });
        const formHasEmptyInput = [
            ...inputs
        ].some((input)=>input.value.length === 0);
        if (formHasEmptyInput) form.classList.add('invalid');
    };
    button.onclick = (e)=>{
        e.preventDefault();
        const formData = [
            ...new FormData(form).entries()
        ];
        const url = new URL(document.location.href);
        const savedQueryParams = window1.localStorage?.getItem('savedQueryParams');
        let ycid = null;
        if (savedQueryParams) {
            const searchParams = new URLSearchParams(savedQueryParams);
            [
                ...searchParams.entries()
            ].forEach(([key, value])=>{
                url.searchParams.append(key, value);
            });
        }
        ym(49633516, 'getClientID', (clientID)=>{
            ycid = clientID;
        });
        const ubtcuid = document.cookie.split('; ').find((row)=>row.startsWith('_ubtcuid'))?.split('=')[1];
        const domainUserId = window1.Snowplow?.getTrackerCf().getDomainUserId();
        const dataObject = formData.reduce((acc, [key, val])=>({
                ...acc,
                [key]: val
            }), {
            urlUtm: url.href.replace('#form-demo', ''),
            ycid,
            ubtcuid,
            domainUserId
        });
        if (validateForm().includes(false)) {
            updateInputsClasses();
            return;
        }
        inputs.forEach((input)=>{
            if (input) input.value = '';
        });
        content.classList.add('success');
        window1?.dataLayer?.push({
            event: 'request_demo_form_send'
        });
        Object.keys(dataObject).forEach((key)=>{
            dataObject[key] = dataObject[key]?.replaceAll('>', '&#62;').replaceAll('<', '&#60;').replaceAll('&', '&#38;').replaceAll(/eval/gi, '&#101;&#118;&#97;&#108;');
        });
        fetch(api, {
            method: 'post',
            body: JSON.stringify(dataObject),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(()=>{
            setTimeout(()=>{
                content.classList.remove('success');
                demoModal.style.display = 'none';
                document.body.style.overflow = '';
            }, 5000);
        });
    };
    inputs.forEach((input)=>{
        const inputWrapper = input.parentElement.parentElement;
        input.onkeyup = ()=>{
            if (!button.classList.contains('invalid')) return;
            const inputsValidationStatus = validateForm();
            const isAllInputsValid = !inputsValidationStatus.includes(false);
            const isAllInputsFilled = isAllInputsValid || inputsValidationStatus.filter((status)=>!status).length === 1 && form.querySelector('.email.invalid.filled');
            inputWrapper.classList.remove('invalid', 'filled');
            form.classList.remove('invalid');
            form.classList.add('half');
            if (isAllInputsFilled) form.classList.remove('half');
            if (isAllInputsValid) button.classList.remove('invalid');
            else updateInputsClasses();
        };
    });
    if (window1.location.hash) {
        const hash = window1.location.hash.substring(1);
        if (hash === 'form-demo') {
            demoModal.style.display = 'flex';
            window1?.dataLayer?.push({
                event: 'request_demo_form_view'
            });
            document.body.style.overflow = 'hidden';
        }
    }
})(window);

//# sourceMappingURL=demoModal.7798a2b4.js.map
